'use strict';

import PropTypes from 'prop-types';

import React from 'react';
import { connect } from 'react-redux';

import PlayLink from './PlayLink.jsx';
import { updateNetworkOfflineMessage } from '../../actions/networkStatus';
import { networkOnlineSelector } from '../../reducers/network';

class PlayLinkContainer extends React.Component {
    render() {
        return <PlayLink {...this.props} />;
    }
}

PlayLinkContainer.propTypes = {
    to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
    query: PropTypes.object,
    hash: PropTypes.string,
    state: PropTypes.object,
    activeClassName: PropTypes.string,
    activeStyle: PropTypes.string,
    children: PropTypes.node,
    isExternal: PropTypes.bool,
    isIndexLink: PropTypes.bool,
    scrollToTop: PropTypes.bool,
    onClick: PropTypes.func,
    onFocus: PropTypes.func,
    onAfterClick: PropTypes.func,
    regTestSpec: PropTypes.string,
};

const mapStateToProps = (state) => {
    return {
        networkOnline: networkOnlineSelector(state),
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        updateNetworkOfflineMessage: (href) => {
            dispatch(updateNetworkOfflineMessage(true, href));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(PlayLinkContainer);
